import { z } from 'zod';

import {
	PidRequestedOperationV4,
	PidRequestedOperationStatusV4,
} from '../../../../../api/generated/cz.partners.pid.backofficegateway.signs';
import { createEnumArraySchema } from '../../../../../helpers/zod/createEnumArraySchema';

export const clientAndIdentityFilterFormSchema = z.object({
	operationType: z.enum(PidRequestedOperationV4).optional(),
	operationStatuses: createEnumArraySchema(PidRequestedOperationStatusV4),
});

export type ClientAndIdentityFilterForm = z.infer<
	typeof clientAndIdentityFilterFormSchema
>;
